import React, { useMemo } from 'react';
import { Stack } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';

type Props = {
  item: LineItem;
};

export const LineItemSizeAndQuantity: React.FC<Props> = ({
  item: {
    attributes: { inventory, skuId, quantity }
  }
}) => {
  const selectedSku = useMemo(
    () => inventory.find(({ id }) => id === skuId) || inventory[0],
    [skuId, inventory]
  );

  return (
    <Stack space={3} direction="horizontal">
      <span>Size: {selectedSku?.size || ''}</span>
      <span>Qty: {quantity}</span>
    </Stack>
  );
};
